import {
  Step,
  StepCommand,
  StepCommandV3,
  ChildPipelineStep,
} from 'src/components/pipelines/models';
import { LogState } from 'src/components/pipelines/redux/reducers/log';

export const fullLogToByteArray = (
  fullLog: string
): Uint8Array<ArrayBufferLike> => new TextEncoder().encode(fullLog);

export const getLogLinesFromByteArrayPositions = (
  byteArray: Uint8Array<ArrayBufferLike>,
  firstByte: number,
  lastByte: number
): string[] =>
  new TextDecoder().decode(byteArray.slice(firstByte, lastByte)).split('\n');

export const extractCommandsFromFullLog = (
  fullLog: string,
  stepCommands: StepCommand[]
): {
  commands: LogState['commands'][string];
  stepLogs: LogState['stepLogs'][string];
} => {
  const fullLogByteArray = fullLogToByteArray(fullLog);
  const stepLogs = new Map();
  const commands = [] as string[][];

  stepCommands.forEach((stepCommand, index) => {
    const logLines = getLogLinesFromByteArrayPositions(
      fullLogByteArray,
      stepCommand.log_range.first_byte_position,
      stepCommand.log_range.last_byte_position
    );
    commands[index] = logLines;
    stepLogs.set(index, logLines);
  });
  return { commands, stepLogs };
};

export const extractCommandsV3FromFullLog = (
  fullLog: string,
  stepCommandsV3: StepCommandV3[]
): {
  commands: LogState['commands'][string];
  stepLogs: LogState['stepLogs'][string];
} => {
  const fullLogByteArray = fullLogToByteArray(fullLog);
  const stepLogs = new Map();
  const commands = [] as string[][];

  let byteCount = 0;
  stepCommandsV3.forEach((stepCommandV3, index) => {
    const logLines = getLogLinesFromByteArrayPositions(
      fullLogByteArray,
      byteCount,
      byteCount + stepCommandV3.byteCount
    );
    commands[index] = logLines;
    stepLogs.set(index, logLines);
    byteCount += stepCommandV3.byteCount;
  });
  return { commands, stepLogs };
};

const findStepWithStatus = (
  stepsArray: (Step | ChildPipelineStep)[],
  matcher: (x: Step | ChildPipelineStep) => boolean
): string | undefined => stepsArray.find(matcher)?.uuid;

export const selectCurrentStepUuid = (
  stepsMap: Record<string, Step | ChildPipelineStep>,
  actionStepUuid?: string
): string => {
  const stepsArray = Object.values(stepsMap);
  if (!stepsArray?.length) return '';

  if (actionStepUuid && stepsArray.some(step => step?.uuid === actionStepUuid))
    return actionStepUuid;

  return (
    findStepWithStatus(
      stepsArray,
      x => !x.isChildStep && x.isSyncing && !x.isPending
    ) ||
    findStepWithStatus(stepsArray, x => !x.isChildStep && x.isFailed) ||
    stepsArray[0]?.uuid ||
    ''
  );
};
